////directive controller function
//var serviceContractWarningController = function ($scope) {
//};
////directive controller function injections
//serviceContractWarningController.$inject = ['$scope'];
////directive link function

////directive link function injections
//serviceContractWarningController.$inject = ['$scope', '$element', '$attrs'];
//directive controller function
var serviceContractWarningController = function ($scope, $state) {
    $scope.closePopup = function () {
        $scope.showServiceContractWarning = false;
        $state.go('bookappointment.schedule');
    };
};
//directive controller function injections
serviceContractWarningController.$inject = ['$scope', '$state'];
//directive link function
var ServiceContractWarningLinkFunction = function ($scope, $iElement, $iAttrs) {
};

module.exports = function () {
    return {
        replace: false,
        templateUrl: 'template/directives/service-contract-warning',
        restrict: 'E',
        link: ServiceContractWarningLinkFunction,
        controller: serviceContractWarningController,
        scope: {
            showServiceContractWarning: '=?',
            selectedTime: '=?'
        }
    }
};
